<template>
  <div>
    <b-row>
      <template v-if="title1">
        <b-col md="6" sm="6">
          <slot name="header-title">
            <h4 class="header-title">{{ title }}</h4>
          </slot>
        </b-col>
        <b-col md="6" sm="6">
          <slot name="header-title-1">
            <h4 class="header-title">{{ title1 }}</h4>
          </slot>
        </b-col>
      </template>
      <template v-else>
        <b-col md="12">
          <slot name="header-title">
            <h4 class="header-title">{{ title }}</h4>
          </slot>
        </b-col>
      </template>
    </b-row>
    <b-row class="body">
      <template v-if="multiple">
        <slot />
      </template>
      <template v-else-if="only">
        <b-col md="12">
          <slot name="main-text-1" />
        </b-col>
      </template>
      <template v-else>
        <b-col md="6" sm="6" class="no-pd">
          <slot name="main-text-1" />
        </b-col>
        <b-col md="6" sm="6" class="no-pd">
          <slot name="main-text-2" />
        </b-col>
      </template>
    </b-row>
  </div>
</template>
<script>
export default {
  name: 'Content',
  props: {
    title: { type: String, required: true },
    title1: { type: String, required: false },
    multiple: { type: Boolean, required: false, default: false },
    only: { type: Boolean, required: false, default: false },
  },
};
</script>
